import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadge = () => {
  return (
    <div className="flex items-center justify-center gap-2 text-muted-foreground">
      <Icon name="Shield" size={16} />
      <span className="caption text-xs md:text-sm">Secured with SSL encryption</span>
    </div>
  );
};

export default SecurityBadge;